/**
 * Asynchronously loads the component for MyautoiqCampaignsLeadsPage
 */

import { lazyLoad } from 'utils/loadable';

export const MyautoiqCampaignsLeadsPage = lazyLoad(
  () => import('./index'),
  module => module.MyautoiqCampaignsLeadsPage,
);
